import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';
import Fade from '@mui/material/Fade';
import { useState } from 'react';
import { VIDEO_STATUS } from '../types/videoStatus';
import { VideoManagerItem } from '../types/videos';

type Props = {
  onApprove: () => void;
  onClip: (format: string) => void;
  onReUpload: () => void;
  onGenerateMetadata?: () => void;
  onConvertToVertical?: () => void;
  onDownloadMp4: () => void;
  onDelete: () => void;
  onKeepVideo: () => void;
  video: VideoManagerItem;
  reClip: boolean;
}

export default function VideoMenu
({ onApprove, video, reClip, onClip, onReUpload, onDelete, onDownloadMp4, onGenerateMetadata, onConvertToVertical, onKeepVideo }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (<><IconButton
    size={'small'}
    onClick={handleClick}
  >
    <MoreVertIcon sx={{ fill: '#666', m: 1, cursor: 'pointer' }}/>
  </IconButton>
    <Menu
      id="fade-menu"
      MenuListProps={{
        'aria-labelledby': 'fade-button',
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      TransitionComponent={Fade}
    >
      <MenuItem title={video.status === VIDEO_STATUS.CLIPPING_IN_PROGRESS ? 'clipping in' +
        ' progress..' : (video.child_videos.some(({ has_been_played }) => has_been_played) ? 'Child video has been played' : 'Re-Clip') } disabled={video.child_videos.some(({ has_been_played }) => has_been_played) || video.status === VIDEO_STATUS.CLIPPING_IN_PROGRESS}
                onClick={() => {
                  onClip('vertical');
                  handleClose();
                }}>{reClip ? 'Re-clip' : 'Clip'}</MenuItem>
      { video.format === 'horizontal' && <MenuItem onClick={() => {
        onClip('horizontal');
        handleClose();
      }}>Clip to horizontal</MenuItem>}
      { video.format === 'vertical' && onGenerateMetadata && <MenuItem onClick={() => {
        onGenerateMetadata();
        handleClose();
      }} disabled={Boolean(video.opus_project_id)}>Generate metadata</MenuItem>}
       { video.format === 'horizontal' && onConvertToVertical && <MenuItem onClick={() => {
        onConvertToVertical();
        handleClose();
      }} disabled={video.child_videos.length > 0}>Convert to vertical</MenuItem>}
      <MenuItem disabled={video.has_been_played || video.child_videos.some(({ has_been_played }) => has_been_played)} onClick={() => {
        onReUpload();
        handleClose()
      }}>Re-upload</MenuItem>
      <MenuItem onClick={() => {
        onDownloadMp4();
        handleClose();
      }}>Download mp4</MenuItem>
      { video.status !== VIDEO_STATUS.REQUIRES_REVIEW && <MenuItem disabled={video.has_been_played || video.duration >= 600}
                onClick={() => onApprove()}>{video.status === VIDEO_STATUS.APPROVED ? 'Withdraw' +
        ' approval' : 'Approve'}</MenuItem>}
      {  video.status === VIDEO_STATUS.REQUIRES_REVIEW && <MenuItem onClick={() => onKeepVideo()}>Keep</MenuItem>}
      <MenuItem onClick={() => {
        if (window.confirm('Are you sure you want to delete this source video?')) {
          onDelete();
        }
        handleClose();
      }}>Delete</MenuItem>
    </Menu>
  </>);
};